webpackJsonp([247257851810749],{

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(81);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(75);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Td = exports.Tbody = exports.Th = exports.Tr = exports.Thead = exports.Table = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _tableContext = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var omit = function omit(obj, omitProps) {
	  return Object.keys(obj).filter(function (key) {
	    return omitProps.indexOf(key) === -1;
	  }).reduce(function (returnObj, key) {
	    return _objectSpread({}, returnObj, _defineProperty({}, key, obj[key]));
	  }, {});
	};
	
	var allowed = function allowed(props) {
	  return omit(props, ['inHeader', 'columnKey', 'headers']);
	};
	
	var Table =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  function Table(props) {
	    var _this;
	
	    _classCallCheck(this, Table);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));
	    _this.state = {
	      headers: {}
	    };
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: "render",
	    value: function render() {
	      var headers = this.state.headers;
	      var classes = (this.props.className || '') + ' responsiveTable';
	      return _react["default"].createElement(_tableContext.Provider, {
	        value: headers
	      }, _react["default"].createElement("table", _extends({}, allowed(this.props), {
	        className: classes
	      })));
	    }
	  }]);
	
	  return Table;
	}(_react["default"].Component);
	
	exports.Table = Table;
	
	var Thead = function Thead(props) {
	  return _react["default"].createElement("thead", allowed(props), _react["default"].cloneElement(props.children, {
	    inHeader: true
	  }));
	};
	
	exports.Thead = Thead;
	
	var TrInner =
	/*#__PURE__*/
	function (_React$Component2) {
	  _inherits(TrInner, _React$Component2);
	
	  function TrInner(props) {
	    var _this2;
	
	    _classCallCheck(this, TrInner);
	
	    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TrInner).call(this, props));
	    var headers = props.headers;
	
	    if (headers && props.inHeader) {
	      _react["default"].Children.map(props.children, function (child, i) {
	        if (child) {
	          headers[i] = child.props.children;
	        }
	      });
	    }
	
	    return _this2;
	  }
	
	  _createClass(TrInner, [{
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      return _react["default"].createElement("tr", allowed(this.props), children && _react["default"].Children.map(children, function (child, i) {
	        return child && _react["default"].cloneElement(child, {
	          key: i,
	          columnKey: i
	        });
	      }));
	    }
	  }]);
	
	  return TrInner;
	}(_react["default"].Component);
	
	var Tr = function Tr(props) {
	  return _react["default"].createElement(_tableContext.Consumer, null, function (headers) {
	    return _react["default"].createElement(TrInner, _extends({}, props, {
	      headers: headers
	    }));
	  });
	};
	
	exports.Tr = Tr;
	
	var Th = function Th(props) {
	  return _react["default"].createElement("th", allowed(props));
	};
	
	exports.Th = Th;
	
	var Tbody = function Tbody(props) {
	  return _react["default"].createElement("tbody", allowed(props));
	};
	
	exports.Tbody = Tbody;
	
	var TdInner =
	/*#__PURE__*/
	function (_React$Component3) {
	  _inherits(TdInner, _React$Component3);
	
	  function TdInner() {
	    _classCallCheck(this, TdInner);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(TdInner).apply(this, arguments));
	  }
	
	  _createClass(TdInner, [{
	    key: "render",
	    value: function render() {
	      if (this.props.colSpan) {
	        return _react["default"].createElement("td", allowed(this.props));
	      }
	
	      var _this$props = this.props,
	          headers = _this$props.headers,
	          children = _this$props.children,
	          columnKey = _this$props.columnKey;
	      var classes = (this.props.className || '') + ' pivoted';
	      return _react["default"].createElement("td", {
	        className: classes
	      }, _react["default"].createElement("div", {
	        className: "tdBefore"
	      }, headers[columnKey]), children !== undefined ? children : _react["default"].createElement("div", null, "\xA0"));
	    }
	  }]);
	
	  return TdInner;
	}(_react["default"].Component);
	
	var Td = function Td(props) {
	  return _react["default"].createElement(_tableContext.Consumer, null, function (headers) {
	    return _react["default"].createElement(TdInner, _extends({}, props, {
	      headers: headers
	    }));
	  });
	};
	
	exports.Td = Td;

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Consumer = exports.Provider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(76));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// use the polyfill only if Context API not available (react<16)
	var createContext = _react["default"].createContext || _createReactContext["default"];
	
	var _createContext = createContext({}),
	    Provider = _createContext.Provider,
	    Consumer = _createContext.Consumer;
	
	exports.Consumer = Consumer;
	exports.Provider = Provider;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSuperResponsiveTable = __webpack_require__(86);
	
	var _crimsonTide = __webpack_require__(5);
	
	var _reactObfuscate = __webpack_require__(111);
	
	var _reactObfuscate2 = _interopRequireDefault(_reactObfuscate);
	
	__webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlanningGroup = function PlanningGroup() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_crimsonTide.PageTitle, { name: 'ModernThink Employee Survey Planning Group' }),
	    _react2.default.createElement(
	      _reactSuperResponsiveTable.Table,
	      { 'class': 'Table Table-bordered Table-hover Table-condensed' },
	      _react2.default.createElement(
	        _reactSuperResponsiveTable.Thead,
	        null,
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Th,
	            null,
	            'Name'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Th,
	            null,
	            'Representing'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Th,
	            null,
	            'Email'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Th,
	            null,
	            'Phone'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactSuperResponsiveTable.Tbody,
	        null,
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Jon Acker '
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Office of Institutional Research & Assessment (OIRA)'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            _react2.default.createElement(_reactObfuscate2.default, { email: 'jon.acker@ua.edu' })
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            '348-4432'
	          )
	        ),
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Lorne Kuffel'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Office of Institutional Research & Assessment (OIRA)'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            _react2.default.createElement(_reactObfuscate2.default, { email: 'lkuffel@ua.edu' })
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            '348-7204'
	          )
	        ),
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Russell Matthews'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Faculty Advisor'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            _react2.default.createElement(_reactObfuscate2.default, { email: 'ramatthews2@ua.edu' })
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            '348-6289'
	          )
	        ),
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Jacob Pleitz'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Office of Institutional Research & Assessment (OIRA)'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            _react2.default.createElement(_reactObfuscate2.default, { email: 'jdpleitz@ua.edu' })
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            '348-7213'
	          )
	        ),
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Travis Railsback'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Human Resources'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            _react2.default.createElement(_reactObfuscate2.default, { email: 'trailsback@fa.ua.edu' })
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            '348-0869'
	          )
	        ),
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Tim Salazar'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Student Life'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            _react2.default.createElement(_reactObfuscate2.default, { email: 'trsalazar@ua.edu' })
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            '348-4903'
	          )
	        ),
	        _react2.default.createElement(
	          _reactSuperResponsiveTable.Tr,
	          null,
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Monica Watts'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            'Office of Strategic Communications'
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            _react2.default.createElement(_reactObfuscate2.default, { email: 'monica.watts@ua.edu' })
	          ),
	          _react2.default.createElement(
	            _reactSuperResponsiveTable.Td,
	            null,
	            '348-5411'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = PlanningGroup;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-planning-group-js-e0aba397d7ad0df95d04.js